

































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';
import { GlobalEventType } from "@/models/GlobalEventType";
import { emitter } from "@/plugins/emitter";

@Component({
    model: {
        prop: "model",
        event: "photoChanged"
    }})
export default class PhotoCapture extends Vue {
    // Fields

    // Component Properties
    @Prop({ required: true })
    public model!: Blob | null;

    // Getter & Setter
    public get video(): HTMLVideoElement {
        return this.$refs.video as HTMLVideoElement;
    }
    public get focusFrame(): HTMLElement {
        return this.$refs.focusFrame as HTMLElement;
    }
    public get canvas(): HTMLCanvasElement {
        return this.$refs.canvas as HTMLCanvasElement;
    }

    public get photo(): Blob | null {
        return this.model;
    }

    public set photo(value: Blob | null) {
        this.firePhotoChanged(value);
    }

    public firePhotoChanged(value: Blob | null): void {
        this.$emit('photoChanged', value);
    }

    // Lifecycle Hooks
    public mounted() {
        this.startCamera();
    }

    public beforeDestroy() {
        this.stopCamera();
    }

    // Methods
    private async startCamera() {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
            this.video.srcObject = stream;
        } catch (error) {
            console.error("Error accessing camera:", error);
            emitter.emit(GlobalEventType.ErrorOccurred, this.$t("photoCapture.errorAccessingCamera"));
        }
    }

    private capturePhoto() {
        const videoRect = this.video.getBoundingClientRect();
        const frameRect = this.focusFrame.getBoundingClientRect();

        const videoAspect = this.video.videoWidth / this.video.videoHeight;
        const displayAspect = videoRect.width / videoRect.height;

        let scaleX, scaleY, offsetX = 0, offsetY = 0;

        if (videoAspect > displayAspect) {
            scaleY = this.video.videoHeight / videoRect.height;
            const actualVideoWidth = videoRect.height * videoAspect;
            scaleX = this.video.videoWidth / actualVideoWidth;
            offsetX = (videoRect.width - actualVideoWidth) / 2;
        } else {
            scaleX = this.video.videoWidth / videoRect.width;
            const actualVideoHeight = videoRect.width / videoAspect;
            scaleY = this.video.videoHeight / actualVideoHeight;
            offsetY = (videoRect.height - actualVideoHeight) / 2;
        }

        const sx = (frameRect.left - videoRect.left - offsetX) * scaleX;
        const sy = (frameRect.top - videoRect.top - offsetY) * scaleY;
        const sw = frameRect.width * scaleX;
        const sh = frameRect.height * scaleY;

        this.canvas.width = sw;
        this.canvas.height = sh;
        const context = this.canvas.getContext('2d');

        if (!context) {
            console.error("Failed to get canvas context");
            return;
        }

        context.drawImage(this.video, sx, sy, sw, sh, 0, 0, sw, sh);

        this.canvas.toBlob((blob) => {
            if (blob) {
                this.photo = blob;
            }
        }, 'image/jpeg', 0.95);
    }

    public stopCamera() {
        const stream = this.video.srcObject as MediaStream;
        if (stream) {
            stream.getTracks().forEach(track => track.stop());
            this.video.srcObject = null;
        }
    }
}
